type MinusIconProps = {
  color: string;
};

export const MinusIcon = ({ color }: MinusIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 21 20"
  >
    <path
      data-name="Tracé 8241"
      d="M8.8 18.482H.656v-3.589h20v3.589H8.8z"
      transform="translate(-.156 -6.667)"
      fill={color}
      stroke={"transparent"}
    />
    <path
      data-name="Rectangle 6272"
      transform="translate(.5)"
      fill={"none"}
      d="M0 0h20v20H0z"
    />
  </svg>
);
